import Address from './address'
export const TOKEN_KEY = 'netbox-token'
export const ADDRESS = Address
export const MOBILE_REG = /^1[3456789]\d{9}$/
export const PASSWORD_REG = /^(?!.*\s)(?:(?=.*[A-Z])(?=.*[a-z])(?=.*\d)|(?=.*[A-Z])(?=.*[a-z])(?=.*[\W_])|(?=.*[A-Z])(?=.*[\W_])(?=.*\d)|(?=.*[a-z])(?=.*\d)(?=.*[\W_]))[A-Za-z\d\W_]{8,20}$/
export const EMAIL_REG = /^[\w\d-.]+@[a-z0-9]+\.[a-z]+$/i
export const IP_REG = /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/

export const passwordValidator = (rule, value) => {
  if (!value || !value.trim()) {
    return Promise.resolve()
  }
  if (!PASSWORD_REG.test(value)) {
    return Promise.reject(new Error('8-20位，并且包含大写字母、小写字母、数字和特殊字符中三种及以上组合'))
  }
  return Promise.resolve()
}

export const financeStatusMap = {
  ALIPAY_RECHARGE: { name: '支付宝充值', symbol: '+' },
  ORDER_CLOSE: { name: '订单关闭', symbol: '+' },
  DEVICE_RETURN: { name: '订单退货', symbol: '+' },
  BANK_TRANSFER: { name: '银行转账', symbol: '+' },
  SERVICE_FEE: { name: '续平台服务费', symbol: '-' },
  BUY_NETBOX: { name: '购买网络盒子', symbol: '-' },
  OVERLAY_PACKAGE: { name: '续叠加包', symbol: '-' },
  REFUELING_PACKAGE: { name: '续加油包', symbol: '-' },
  MANUAL_DEDUCTION: { name: '手动扣款', symbol: '-' }
}

export const FLOW_STATUS_MAP = {
  ACTIVATION: '激活',
  DEACTIVATION: '停卡'
}

export const DEVICE_STATUS_MAP = {
  ACTIVATION: '已激活',
  INVENTORY: '未激活',
  EXPIRED: '已过期'
}

export const RENEW_TYPE_MAP = {
  SERVICE_FEE: '平台服务费',
  REFUELING_PACKAGE: '加油包',
  OVERLAY_PACKAGE: '叠加包'
}

export const RENEW_ITEM_TYPE_MAP = {
  CARD: '卡套餐',
  DEVICE: '设备',
  PACKAGE: '打包套餐',
  OVERLAY: '加油包&叠加包'
}

export const MQTT_VERSION_FOR_5G = '0.71'
